import { render, staticRenderFns } from "./Sentoperatorfromstation.vue?vue&type=template&id=9b04812a&scoped=true&"
import script from "./Sentoperatorfromstation.vue?vue&type=script&lang=js&"
export * from "./Sentoperatorfromstation.vue?vue&type=script&lang=js&"
import style0 from "./Sentoperatorfromstation.vue?vue&type=style&index=0&id=9b04812a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b04812a",
  null
  
)

export default component.exports